import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

import {
  Grid,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  TextField,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Checkbox,
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { FormTitle } from "ui-components/Form";
import { OldSelectField } from "./OldSelectField";
import { Fragment, useState, useEffect } from "react";
import { BackButton } from "layouts/views/components/Button";

import { getLocationsByRack } from "services/data.internal.service";
import { Error_ } from "ui-components/Alert";

function EditPreferredLocationInfo(props) {
  const {
    warehouseCode,
    zoneID,
    rack,
    locationsId,
    skusList,
    mode,
    renderDialog,
    editSKU,
    customerCode,
    vendorCode,
    setVendorCode,
    skuCode,
    setSKUCode,
    selectedLocations,
    setSelectedLocations,
    selectedSKUs,
    setSelectedSKUs,
    routingData,
    setRoutingData,
    routingDirection,
    setRoutingDirection,
    editStatus,
    setAlert,
  } = props;

  const [existingLocations, setExistingLocations] = useState([]);

  const [tableData, setTableData] = useState([]);
  useQuery({
    queryKey: ["locations_by_rack", warehouseCode, zoneID, rack],
    queryFn: () =>
      getLocationsByRack({
        whCode: warehouseCode,
        id: zoneID,
        rack: rack,
      }),
    refetchOnWindowFocus: false,
    enabled: warehouseCode != "" && zoneID != "" && rack != "",
    onSuccess: (data) => {
      if (data.data) {
        const locations = data.data;
        console.log(locations)
        if (locations.some(x => !Boolean(x.lLevel) || !Boolean(x.bay) || !Boolean(x.slot))) {
          setAlert(<Error_ content={"Unable to draw front view"} onChange={setAlert} />)
          return;
        }
        const seen = new Set();
        for (const item of locations) {
          const key = `${item.lLevel}-${item.bay}-${item.slot}`;
          if (seen.has(key)) {
            setAlert(<Error_ content={"Unable to draw front view"} onChange={setAlert} />)
            return;
          }
          seen.add(key);
        }

        let maxRow = Math.max.apply(
          Math,
          locations.map((x) => x.lLevel)
        );
        let maxColumn = Math.max.apply(
          Math,
          locations.map((x) => x.bay)
        );
        let numberOfSlot = Math.max.apply(
          Math,
          locations.map((x) => x.slot)
        );
        if (numberOfSlot > 0) maxColumn = maxColumn * numberOfSlot;
        let table = [];
        for (var i = 0; i < maxRow; i++) {
          let row = Array(maxColumn).fill("");
          let locationsInRow = locations.filter((x) => x.lLevel === i + 1);
          if (locationsInRow.length > 0) {
            for (var j = 0; j < locationsInRow.length; j++) {
              let index = (locationsInRow[j].bay - 1) * numberOfSlot + locationsInRow[j].slot - 1;
              row[index] = locationsInRow[j].locationID;
            }
          }
          table.unshift(row);
        }
        setTableData(table);
      }
    },
  });

  useEffect(() => {
    if (selectedSKUs.length > 0) {
      const flattenSKULoc = skusList
        .filter(
          (skuLoc) =>
            selectedSKUs.findIndex(
              (selectedSKU) =>
                selectedSKU.skuCode === skuLoc.skuCode &&
                selectedSKU.customerCode === skuLoc.customerCode &&
                selectedSKU.vendorCode == skuLoc.vendorCode
            ) !== -1
        )
        .flatMap((itemLoc) => itemLoc.locations.map((x) => x.locationID));
      const distinctLoc = new Set(flattenSKULoc);
      const selectedLoc = Array.from(distinctLoc);
      setExistingLocations(selectedLoc);
    } else {
      setExistingLocations([]);
    }
  }, [selectedSKUs]);

  useEffect(() =>{
    setSelectedLocations([]);
  }, [customerCode, vendorCode, skuCode])

  const custProp = {
    disabled: true,
    value: customerCode || "",
    required: true,
    name: "customerCode",
    label: "Customer Code",
  };

  const routeValid = (locations) => {
    if (locations.some(x => !Boolean(x.lLevel) || !Boolean(x.bay) || !Boolean(x.slot))) {
      return false;
    }
    const seen = new Set();
    for (const item of locations) {
      const key = `${item.lLevel}-${item.bay}-${item.slot}`;
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
    }
    return true;
  }

  return (
    <MDBox>
      <>
        <FormTitle
          title={
            mode == "edit"
              ? "Edit Preferred Location Sequence"
              : "Delete SKU/Location in Preferred Location"
          }
        />

        <MDBox mt={1.625}>
          <Fragment>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  sx={{ mb: 1.5 }}
                  value={warehouseCode}
                  fullWidth
                  label={"Warehouse Code"}
                  disabled
                />
              </Grid>
              <Grid item xs={6}>
                <TextField sx={{ mb: 1.5 }} value={zoneID} fullWidth label={"Zone ID"} disabled />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField sx={{ mb: 1.5 }} value={rack} fullWidth label={"Rack"} disabled />
              </Grid>
            </Grid>
          </Fragment>

          {mode == "delete" && (
            <>
              <Fragment>
              <Grid container spacing={2}>
                  <Grid item xs={12}>
                  <MDBox pt={1} pb={2}>
                      <MDTypography color="info" variant="h5">
                        Filter for Location IDs (Settings will be deleted as filtered)
                      </MDTypography>
                    </MDBox>
                  </Grid>
              </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField sx={{ mb: 1.5 }} {...custProp} fullWidth />
                  </Grid>
                  <Grid item xs={6}>
                    <OldSelectField
                      field={{ name: "vendorCode", label: "Vendor Code", value: vendorCode }}
                      options={skusList.reduce((accumulator, currentValue) => {
                        if (currentValue.customerCode === customerCode) {
                          if (currentValue.vendorCode) {
                            if (!accumulator.includes(currentValue.vendorCode)) {
                              accumulator.push(currentValue.vendorCode);
                            }
                          }
                        }

                        return accumulator;
                      }, [])}
                      onChange={(e, option) => setVendorCode(option)}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <OldSelectField
                      field={{ name: "skuCode", label: "SKU Code", value: skuCode }}
                      options={skusList.reduce((accumulator, currentValue) => {
                        if (currentValue.customerCode === customerCode) {
                          if (
                            vendorCode === "" ||
                            vendorCode === null ||
                            currentValue.vendorCode === vendorCode
                          ) {
                            if (!accumulator.includes(currentValue.skuCode)) {
                              accumulator.push(currentValue.skuCode);
                            }
                          }
                        }
                        return accumulator;
                      }, [])}
                      onChange={(e, option) => {
                        setSKUCode(option);
                      }}
                    />
                  </Grid>
                </Grid>
              </Fragment>
              <Fragment>
                {/*front view table */}
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <MDBox pt={1} pb={2}>
                      <MDTypography color="info" variant="h5">
                        Rack Front View
                      </MDTypography>
                    </MDBox>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <LocationTable
                      tableData={tableData}
                      selectedLocation={locationsId}
                      customerCode={customerCode}
                      vendorCode={vendorCode}
                      skuCode={skuCode}
                    />
                  </Grid>
                </Grid>
              </Fragment>
              <Fragment>
                {/*list of location ids with checkbox */}
                <LocationCheckboxList
                  locationItemsList={locationsId}
                  customerCode={customerCode}
                  vendorCode={vendorCode}
                  skuCode={skuCode}
                  selectedLocations={selectedLocations}
                  setSelectedLocations={setSelectedLocations}
                />
              </Fragment>
              <Fragment>
                {/*delete button */}
                <MDBox mt={2} width="100%" display="flex" justifyContent="center">
                  <MDButton
                    sx={{ marginLeft: "1.5rem" }}
                    type="button"
                    onClick={() => {
                      renderDialog({
                        locationID: selectedLocations,
                        customerCode: customerCode,
                        vendorCode: vendorCode,
                        skuCode: skuCode,
                      });
                    }}
                    variant="gradient"
                    color="error"
                  >
                    Delete Location
                  </MDButton>
                  <BackButton url="/setup/preferred-location" />
                </MDBox>
              </Fragment>
            </>
          )}
          {mode == "edit" && (
            <>
              <Fragment>
                {/*list of skus with checkbox */}
                <SKUCheckboxList
                  itemLocationsList={skusList}
                  selectedSKUs={selectedSKUs}
                  setSelectedSKUs={setSelectedSKUs}
                />
              </Fragment>
              {(existingLocations.length !== 0 && routeValid(existingLocations)) && (
                <>
                  <Fragment>
                    {/*routing table */}
                    <RoutingForm
                      table={tableData}
                      selectedSKUs={selectedSKUs}
                      existingLocations={existingLocations}
                      routingData={routingData}
                      setRoutingData={setRoutingData}
                      routingDirection={routingDirection}
                      setRoutingDirection={setRoutingDirection}
                    />
                  </Fragment>
                  <Fragment>
                    {/*submit button and delete button */}
                    <MDBox mt={2} width="100%" display="flex" justifyContent="center">
                      <MDButton
                        sx={{ marginLeft: "1.5rem" }}
                        type="button"
                        onClick={() => {
                          editSKU({ skus: selectedSKUs, routingData: routingData });
                        }}
                        variant="gradient"
                        color="info"
                        disabled={editStatus}
                      >
                        Edit Sequence
                      </MDButton>
                      <BackButton url="/setup/preferred-location" />
                    </MDBox>
                  </Fragment>
                </>
              )}
            </>
          )}
        </MDBox>
      </>
    </MDBox>
  );
}

const LocationTable = ({ tableData, selectedLocation, customerCode, vendorCode, skuCode }) => {
  const filterLocation = selectedLocation.filter((x) =>
    x.skus.some((y) => {
      return (
        (customerCode == "" || customerCode == null || y.customerCode == customerCode) &&
        (vendorCode == "" ||
          vendorCode == null ||
          (y.vendorCode != null && y.vendorCode != "" && y.vendorCode == vendorCode)) &&
        (skuCode == "" || skuCode == null || y.skuCode == skuCode)
      );
    })
  );

  const LocationTableCell = ({ cellData }) => {
    const cellStyle = {
      fontWeight: filterLocation.some((x) => x.locationID == cellData) ? "700" : "300",
      backgroundColor: filterLocation.some((x) => x.locationID == cellData) ? "Cyan" : selectedLocation.some(x => x.locationID == cellData) ? "Gainsboro" : "white", // Change the color based on isSelected state
      border: "1px solid black",
    };

    return <TableCell style={cellStyle}>{cellData}</TableCell>;
  };

  return (
    <Table style={{ borderCollapse: "collapse", marginBottom: "10px" }}>
      <TableBody>
        {tableData.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            {row.map((cellData, columnIndex) => (
              <LocationTableCell key={`${rowIndex}-${columnIndex}`} cellData={cellData} />
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

const LocationCheckboxList = ({
  locationItemsList,
  customerCode,
  vendorCode,
  skuCode,
  selectedLocations,
  setSelectedLocations,
}) => {
  const filterLocation = locationItemsList.filter((x) =>
    x.skus.some((y) => {
      return (
        (customerCode == "" || customerCode == null || y.customerCode == customerCode) &&
        (vendorCode == null || vendorCode == ""
          ? true
          : y.vendorCode != null && y.vendorCode != "" && y.vendorCode == vendorCode) &&
        (skuCode == "" || skuCode == null ? true : y.skuCode == skuCode)
      );
    })
  );
  const copyArray = JSON.parse(JSON.stringify(filterLocation));
  const toBeListedLocation = copyArray.map((x) => {
    x.skus = x.skus.filter((y) => {
      return (
        (customerCode == "" || customerCode == null || y.customerCode == customerCode) &&
        (vendorCode == null || vendorCode == ""
          ? true
          : y.vendorCode != null && y.vendorCode != "" && y.vendorCode == vendorCode) &&
        (skuCode == "" || skuCode == null ? true : y.skuCode == skuCode)
      );
    });
    return x;
  });

  const toggleItem = (locationID) => {
    if (selectedLocations.includes(locationID)) {
      setSelectedLocations(selectedLocations.filter((item) => item !== locationID));
    } else {
      setSelectedLocations([...selectedLocations, locationID]);
    }
  };
  return (
    <Table>
      <TableHead style={{ display: "table-header-group" }}>
        <TableRow>
          <TableCell style={{border: "1px solid #000"}}>
            <Checkbox
              checked={toBeListedLocation.every((item) => selectedLocations.includes(item.locationID))}
              onChange={() => {
                if (
                  !toBeListedLocation.every((item) => selectedLocations.includes(item.locationID))
                ) {
                  let tobeAdded = [];
                  toBeListedLocation.forEach((item) => {
                    if (!selectedLocations.includes(item.locationID)) {
                      tobeAdded = [...tobeAdded, item.locationID];
                    }
                  });
                  setSelectedLocations([...selectedLocations, ...tobeAdded]);
                } else {
                  setSelectedLocations([]);
                }
              }}
            />
          </TableCell>
          <TableCell style={{border: "1px solid #000"}}>Location ID</TableCell>
          <TableCell style={{border: "1px solid #000"}}>Customer Code</TableCell>
          <TableCell style={{border: "1px solid #000"}}>Vendor Code</TableCell>
          <TableCell style={{border: "1px solid #000"}}>SKU Code</TableCell>
          <TableCell style={{border: "1px solid #000"}}>Route Sequence</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {toBeListedLocation.map((item, index) => (
          <Fragment key={index}>
            <TableRow key={index}>
              <TableCell rowSpan={item.skus.length} style={{border: "1px solid #000", padding:"3px 16px"}}>
                <Checkbox
                  checked={selectedLocations.includes(item.locationID)}
                  onChange={() => toggleItem(item.locationID)}
                />
              </TableCell>
              <TableCell rowSpan={item.skus.length} style={{border: "1px solid #000", padding:"3px 16px"}}>{item.locationID}</TableCell>
              <TableCell style={{border: "1px solid #000", padding:"3px 16px"}}>{item.skus[0].customerCode}</TableCell>
              <TableCell style={{border: "1px solid #000", padding:"3px 16px"}}>{item.skus[0].vendorCode}</TableCell>
              <TableCell style={{border: "1px solid #000", padding:"3px 16px"}}>{item.skus[0].skuCode}</TableCell>
              <TableCell style={{border: "1px solid #000", padding:"3px 16px"}}>{item.skus[0].routeSequence}</TableCell>
            </TableRow>
            {item.skus.slice(1).map((sku, idx) => (
              <TableRow key={idx}>
                <TableCell style={{border: "1px solid #000", padding:"3px 16px"}}>{sku.customerCode}</TableCell>
                <TableCell style={{border: "1px solid #000", padding:"3px 16px"}}>{sku.vendorCode}</TableCell>
                <TableCell style={{border: "1px solid #000", padding:"3px 16px"}}>{sku.skuCode}</TableCell>
                <TableCell style={{border: "1px solid #000", padding:"3px 16px"}}>{sku.routeSequence}</TableCell>
              </TableRow>
            ))}
          </Fragment>
        ))}
      </TableBody>
    </Table>
  );
};

const SKUCheckboxList = ({ itemLocationsList, selectedSKUs, setSelectedSKUs }) => {
  const toggleItem = (sku) => {
    if (
      selectedSKUs.findIndex(
        (selectedSKU) =>
          selectedSKU.skuCode === sku.skuCode &&
          selectedSKU.customerCode === sku.customerCode &&
          selectedSKU.vendorCode == sku.vendorCode
      ) !== -1
    ) {
      setSelectedSKUs(
        selectedSKUs.filter(
          (selectedSKU) =>
            !(
              selectedSKU.skuCode === sku.skuCode &&
              selectedSKU.customerCode === sku.customerCode &&
              selectedSKU.vendorCode == sku.vendorCode
            )
        )
      );
    } else {
      setSelectedSKUs([
        ...selectedSKUs,
        {
          skuCode: sku.skuCode,
          customerCode: sku.customerCode,
          vendorCode: sku.vendorCode,
          locations: sku.locations,
        },
      ]);
    }
  };
  return (
    <Table>
      <TableHead style={{ display: "table-header-group" }}>
        <TableRow>
          <TableCell style={{border: "1px solid #000"}}>
            <Checkbox
              color="primary"
              checked={itemLocationsList.every(
                (item) =>
                  selectedSKUs.findIndex(
                    (selectedSKU) =>
                      selectedSKU.skuCode === item.skuCode &&
                      selectedSKU.customerCode === item.customerCode &&
                      selectedSKU.vendorCode == item.vendorCode
                  ) !== -1
              )}
              onChange={() => {
                if (
                  !itemLocationsList.every(
                    (item) =>
                      selectedSKUs.findIndex(
                        (selectedSKU) =>
                          selectedSKU.skuCode === item.skuCode &&
                          selectedSKU.customerCode === item.customerCode &&
                          selectedSKU.vendorCode == item.vendorCode
                      ) !== -1
                  )
                ) {
                  let tobeAdded = [];
                  itemLocationsList.forEach((item) => {
                    if (
                      selectedSKUs.findIndex(
                        (selectedSKU) =>
                          selectedSKU.skuCode === item.skuCode &&
                          selectedSKU.customerCode === item.customerCode &&
                          selectedSKU.vendorCode == item.vendorCode
                      ) === -1
                    ) {
                      tobeAdded = [
                        ...tobeAdded,
                        {
                          skuCode: item.skuCode,
                          customerCode: item.customerCode,
                          vendorCode: item.vendorCode,
                          locations: item.locations,
                        },
                      ];
                    }
                  });
                  setSelectedSKUs([...selectedSKUs, ...tobeAdded])
                } else {
                  setSelectedSKUs([])
                }
              }}
            />
          </TableCell>
          <TableCell style={{border: "1px solid #000"}}>Customer Code</TableCell>
          <TableCell style={{border: "1px solid #000"}}>Vendor Code</TableCell>
          <TableCell style={{border: "1px solid #000"}}>SKU Code</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {itemLocationsList.map((item, index) => (
          <Fragment key={index}>
            <TableRow key={index}>
              <TableCell style={{border: "1px solid #000", padding:"3px 16px"}}>
                <Checkbox
                  color="primary"
                  checked={
                    selectedSKUs.findIndex(
                      (selectedSKU) =>
                        selectedSKU.skuCode === item.skuCode &&
                        selectedSKU.customerCode === item.customerCode &&
                        selectedSKU.vendorCode == item.vendorCode
                    ) !== -1
                  }
                  onChange={() => toggleItem(item)}
                />
              </TableCell>
              <TableCell style={{border: "1px solid #000", padding:"3px 16px"}}>{item.customerCode}</TableCell>
              <TableCell style={{border: "1px solid #000", padding:"3px 16px"}}>{item.vendorCode}</TableCell>
              <TableCell style={{border: "1px solid #000", padding:"3px 16px"}}>{item.skuCode}</TableCell>
            </TableRow>
          </Fragment>
        ))}
      </TableBody>
    </Table>
  );
};

function RoutingForm({
  table,
  selectedSKUs,
  existingLocations,
  routingData,
  setRoutingData,
  routingDirection,
  setRoutingDirection,
}) {
  //read routingData and get selectedCells
  const selectedCells = existingLocations.map((location) => {
    for (let i = 0; i < table.length; i++) {
      const colIndex = table[i].indexOf(location);
      if (colIndex !== -1) {
        return { rowIndex: i, columnIndex: colIndex };
      }
    }
  });

  const existingSKU = {};

  selectedSKUs.forEach((sku) => {
    sku.locations.forEach((location) => {
      if (existingLocations.includes(location.locationID)) {
        if (!existingSKU[location.locationID]) {
          existingSKU[location.locationID] = { locationID: location.locationID, skus: [] };
        }
        existingSKU[location.locationID].skus.push({
          skuCode: sku.skuCode,
          vendorCode: sku.vendorCode,
          routeSequence: location.routeSequence,
        });
      }
    });
  });

  const selectedRows = selectedCells.map((cell) => cell.rowIndex);
  const selectedColumns = selectedCells.map((cell) => cell.columnIndex);
  const minRowIndex = Math.min(...selectedRows);
  const maxRowIndex = Math.max(...selectedRows);
  const minColumnIndex = Math.min(...selectedColumns);
  const maxColumnIndex = Math.max(...selectedColumns);

  useEffect(() => {
    assignRouting();
  }, [existingLocations, routingDirection]);

  const isCellSelected = (rowIndex, columnIndex) => {
    return selectedCells.some(
      (cell) => cell.rowIndex === rowIndex && cell.columnIndex === columnIndex
    );
  };
  const subTable = [];

  for (let rowIndex = minRowIndex; rowIndex <= maxRowIndex; rowIndex++) {
    const rowData = [];
    for (let columnIndex = minColumnIndex; columnIndex <= maxColumnIndex; columnIndex++) {
      const cellData = selectedCells.find(
        (cell) => cell.rowIndex === rowIndex && cell.columnIndex === columnIndex
      );
      if (cellData) {
        rowData.push(table[cellData.rowIndex][cellData.columnIndex]);
      } else {
        rowData.push("");
      }
    }
    subTable.push(rowData);
  }

  const assignRouting = () => {
    if (existingLocations.length > 0) {
      let routingValue;
      let routes = [];
      if (
        routingDirection == "no-direction" ||
        routingDirection == null ||
        routingDirection == ""
      ) {
        routingValue = Array(existingLocations?.length).fill(0);
        existingLocations.forEach((x, index) =>
          routes.push({ locationId: x, routeSequence: routingValue[index] })
        );
      } else {
        routingValue = Array(existingLocations?.length).fill(1);
        routingValue = routingValue.map((r, index) => r * (index + 1));
        var routeIndex = 0;
        switch (routingDirection) {
          case "right-down":
          case "left-down":
            for (var row = 0; row < subTable.length; row++) {
              if (routingDirection == "right-down") {
                for (var col = 0; col < subTable[0].length; col++) {
                  if (isCellSelected(minRowIndex + row, minColumnIndex + col)) {
                    routes.push({
                      locationId: table[minRowIndex + row][minColumnIndex + col],
                      routeSequence: routingValue[routeIndex++],
                    });
                  }
                }
              } else {
                for (var col = subTable[0].length; col >= 0; col--) {
                  if (isCellSelected(minRowIndex + row, minColumnIndex + col)) {
                    routes.push({
                      locationId: table[minRowIndex + row][minColumnIndex + col],
                      routeSequence: routingValue[routeIndex++],
                    });
                  }
                }
              }
            }
            break;
          case "left-up":
          case "right-up":
            for (var row = subTable.length - 1; row >= 0; row--) {
              if (routingDirection == "right-up") {
                for (var col = 0; col < subTable[0].length; col++) {
                  if (isCellSelected(minRowIndex + row, minColumnIndex + col)) {
                    routes.push({
                      locationId: table[minRowIndex + row][minColumnIndex + col],
                      routeSequence: routingValue[routeIndex++],
                    });
                  }
                }
              } else {
                for (var col = subTable[0].length; col >= 0; col--) {
                  if (isCellSelected(minRowIndex + row, minColumnIndex + col)) {
                    routes.push({
                      locationId: table[minRowIndex + row][minColumnIndex + col],
                      routeSequence: routingValue[routeIndex++],
                    });
                  }
                }
              }
            }
            break;
          case "down-right":
          case "up-right":
            for (let col = 0; col < subTable[0].length; col++) {
              if (routingDirection == "down-right") {
                for (let row = 0; row < subTable.length; row++) {
                  if (isCellSelected(minRowIndex + row, minColumnIndex + col)) {
                    routes.push({
                      locationId: table[minRowIndex + row][minColumnIndex + col],
                      routeSequence: routingValue[routeIndex++],
                    });
                  }
                }
              } else {
                for (var row = subTable.length - 1; row >= 0; row--) {
                  if (isCellSelected(minRowIndex + row, minColumnIndex + col)) {
                    routes.push({
                      locationId: table[minRowIndex + row][minColumnIndex + col],
                      routeSequence: routingValue[routeIndex++],
                    });
                  }
                }
              }
            }
            break;
          case "down-left":
          case "up-left":
            for (var col = subTable[0].length; col >= 0; col--) {
              if (routingDirection == "down-left") {
                for (let row = 0; row < subTable.length; row++) {
                  if (isCellSelected(minRowIndex + row, minColumnIndex + col)) {
                    routes.push({
                      locationId: table[minRowIndex + row][minColumnIndex + col],
                      routeSequence: routingValue[routeIndex++],
                    });
                  }
                }
              } else {
                for (var row = subTable.length - 1; row >= 0; row--) {
                  if (isCellSelected(minRowIndex + row, minColumnIndex + col)) {
                    routes.push({
                      locationId: table[minRowIndex + row][minColumnIndex + col],
                      routeSequence: routingValue[routeIndex++],
                    });
                  }
                }
              }
            }
            break;
          default:
            break;
        }
      }
      setRoutingData(routes);
    }
  };

  const [routingSubTable, setRoutingSubTable] = useState([]);

  useEffect(() => {
    let table = subTable.map((row, rowIndex) =>
      row.map((cellData, columnIndex) => {
        if (isCellSelected(minRowIndex + rowIndex, minColumnIndex + columnIndex)) {
          let data = routingData.filter((r) => r.locationId == cellData);
          if (data[0]) return { ...data[0], existingVal: existingSKU[cellData] };
        }
        return cellData;
      })
    );
    for (var row = 0; row < table.length; row++) {
      if (table[row].every((cell) => cell == "")) {
        table.splice(row, 1);
        row--;
      }
    }
    for (var col = 0; col < table[0].length; col++) {
      if (table.every((row) => row[col] == "")) {
        table.forEach((row) => row.splice(col, 1));
        col--;
      }
    }
    setRoutingSubTable(table);
  }, [routingData]);

  return (
    <>
      <MDBox>
        <MDBox pt={1} pb={2}>
          <MDTypography color="info" variant="h5">
            Route Sequence
          </MDTypography>
        </MDBox>
        <Table style={{ borderCollapse: "collapse", marginBottom: "10px" }}>
          <TableBody>
            {routingSubTable.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {row.map((cellData, columnIndex) => (
                  <TableCell
                    key={`${rowIndex}-${columnIndex}`}
                    style={{
                      backgroundColor: cellData != "" ? "Gainsboro" : "transparent",
                      border: "1px solid black",
                      fontWeight: "bold",
                    }}
                  >
                    {cellData != "" ? (
                      <>
                        {`${cellData.locationId}`}{" "}
                        <span style={{ color: "red", fontWeight: "bold" }}>
                          ({`${cellData.routeSequence}`})
                        </span>
                        {cellData.existingVal &&
                          cellData.existingVal.skus.map((sku, index) => (
                            <span style={{ color: "limegreen", fontWeight: "bold" }}>
                              <br /> {`${sku.skuCode}`}
                              {sku.vendorCode ? `-${sku.vendorCode}` : ``}
                              {` (${sku.routeSequence})`}
                            </span>
                          ))}
                      </>
                    ) : (
                      <>{cellData}</>
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </MDBox>
      <MDBox>
        <MDTypography color="info" variant="h5">
            Routing Direction
          </MDTypography>
        <FormControl style={{ width: "100%" }}>
          <RadioGroup
            row
            value={routingDirection}
            onChange={(e) => setRoutingDirection(e.target.value)}
          >
            <Grid container>
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  style={{ marginLeft: "0px" }}
                  value="no-direction"
                  control={<Radio />}
                  label={
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "300",
                        lineHeight: "1.6",
                        color: "black",
                      }}
                    >
                      No Direction
                    </span>
                  }
                />
                <FormControlLabel
                  style={{ marginLeft: "0px" }}
                  value="right-down"
                  control={<Radio />}
                  label={
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "300",
                        lineHeight: "1.6",
                        color: "black",
                      }}
                    >
                      Right Down
                    </span>
                  }
                />
                <FormControlLabel
                  style={{ marginLeft: "0px" }}
                  value="left-down"
                  control={<Radio />}
                  label={
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "300",
                        lineHeight: "1.6",
                        color: "black",
                      }}
                    >
                      Left Down
                    </span>
                  }
                />
                <FormControlLabel
                  style={{ marginLeft: "0px" }}
                  value="right-up"
                  control={<Radio />}
                  label={
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "300",
                        lineHeight: "1.6",
                        color: "black",
                      }}
                    >
                      Right Up
                    </span>
                  }
                />
                <FormControlLabel
                  style={{ marginLeft: "0px" }}
                  value="left-up"
                  control={<Radio />}
                  label={
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "300",
                        lineHeight: "1.6",
                        color: "black",
                      }}
                    >
                      Left Up
                    </span>
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  style={{ marginLeft: "0px" }}
                  value="down-right"
                  control={<Radio />}
                  label={
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "300",
                        lineHeight: "1.6",
                        color: "black",
                      }}
                    >
                      Down Right
                    </span>
                  }
                />
                <FormControlLabel
                  style={{ marginLeft: "0px" }}
                  value="up-right"
                  control={<Radio />}
                  label={
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "300",
                        lineHeight: "1.6",
                        color: "black",
                      }}
                    >
                      Up Right
                    </span>
                  }
                />
                <FormControlLabel
                  style={{ marginLeft: "0px" }}
                  value="down-left"
                  control={<Radio />}
                  label={
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "300",
                        lineHeight: "1.6",
                        color: "black",
                      }}
                    >
                      Down Left
                    </span>
                  }
                />
                <FormControlLabel
                  style={{ marginLeft: "0px" }}
                  value="up-left"
                  control={<Radio />}
                  label={
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "300",
                        lineHeight: "1.6",
                        color: "black",
                      }}
                    >
                      Up Left
                    </span>
                  }
                />
              </Grid>
            </Grid>
          </RadioGroup>
        </FormControl>
      </MDBox>
    </>
  );
}

export default EditPreferredLocationInfo